import { render, staticRenderFns } from "./OrderPositionsList.vue?vue&type=template&id=bf2d75cc&"
import script from "./OrderPositionsList.vue?vue&type=script&lang=js&"
export * from "./OrderPositionsList.vue?vue&type=script&lang=js&"
import style0 from "./OrderPositionsList.vue?vue&type=style&index=0&id=bf2d75cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports